import { client } from '..';
import { CreateProgram, EditProgram, ProgramsListResponse, ProgramsTypesResponse } from '../models/programModels';

export const getProgramsTypes = async (): Promise<ProgramsTypesResponse> => {
  const { data } = await client.get('/programs/types?perPage=all');
  return data;
};

export const getPrograms = async (nonProfitOrgId?: string): Promise<ProgramsListResponse> => {
  const nonProfitOrgIdParam = nonProfitOrgId !== undefined ? `?npo=${nonProfitOrgId}` : ``;

  const url = `/programs${nonProfitOrgIdParam}`;

  const { data } = await client.get(url);

  return data;
};

export const createProgram = async ({
  name,
  title,
  description,
  programDate,
  nonProfitOrgId,
  budget,
  address,
  location
}: CreateProgram): Promise<any> => {
  const { data } = await client.post('/programs', {
    name,
    title,
    description,
    programDate,
    nonProfitOrgId,
    budget,
    address,
    location
  });

  return data;
};

export const editProgram = async ({
  id,
  name,
  title,
  description,
  programDate,
  nonProfitOrgId,
  budget,
  address,
  location
}: EditProgram): Promise<any> => {
  const { data } = await client.patch(`/programs/${id}`, {
    name,
    title,
    description,
    programDate,
    nonProfitOrgId,
    budget,
    address,
    location
  });

  return data;
};

export const deleteProgram = async ({ id }: { id: string }): Promise<any> => {
  const { data } = await client.delete(`/programs/${id}`);

  return data;
};

export const createManyPrograms = async (body: { programs: CreateProgram[]; npoId?: string }): Promise<any> => {
  const parsedNonProfitOrgId = body.npoId ? `?npoId=${body.npoId}` : '';

  const { data } = await client.post(`/programs/replace${parsedNonProfitOrgId}`, { programs: body.programs });

  return data;
};
